var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Launch"}},[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"imageBox"},[_c('img',{attrs:{"src":_vm.imageCode}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }